import { componentLoader } from "banco-website/Common/components";
import { V4LoanCalculator } from "banco-components/index";

// Props are always empty - previously set via an inline <script nonce="..."> rendered by
// _loan_calculator_v4.html.erb, but that partial can be cached (e.g. Prismic page caching),
// baking in a stale nonce that no longer matches the CSP header and gets the script blocked.
window.fb.loan_calculator_v4_props = window.btoa(JSON.stringify({}));

componentLoader({
  component: V4LoanCalculator,
  propsKey: "loan_calculator_v4_props",
  hookDivId: "loan_calculator_v4"
});
